<template>
  <div class="verify-email-form-wrapper">
    <div class="arrow-container-3">
      <a @click="goToBack"
        ><img src="@/assets/timeslot-images/left-arrow.svg"
      /></a>
    </div>
    <div class="div-block">
      <div class="text-block">Verify email 📤</div>
      <div class="text-block-3">Input the OTP sent to your email</div>
    </div>
    <div class="div-block">
      <FormulateForm id="otp-form">
        <!--        <SingleInput-->
        <!--          v-model="userToken"-->
        <!--          formId="otp-form"-->
        <!--          :boxCount="4"-->
        <!--          textColor="#256ff6"-->
        <!--          borderColor="#d8dae5"-->
        <!--          textSize="45px"-->
        <!--          :withBorder="true"-->
        <!--          borderRadius="10px"-->
        <!--          backgroundColor="transparent"-->
        <!--          type="number"-->
        <!--          :key="formKey"-->
        <!--        />-->
        <div
          style="display: flex; justify-content: center; margin-top: 20px; margin-bottom: 30px; align-items: center;"
        >
          <otp-input
            :isValid="isCodeValid"
            @on-complete="onCompleteHandler"
            @on-paste="onPasteHandler"
            placeholder=""
            separateWrapperClass="separate-wrapper-class"
            separateInputClass="separate-input-class"
            :digits="4"
          >
          </otp-input>
        </div>

        <BaseComponentLoader
          v-if="loader.nonBlockingLoader"
          loaderAlignment="center"
        />
        <!--        <FormulateInput id="otpContinue" type="submit" label="Verify email" />-->
        <!--      </FormulateForm>-->
        <!--      <div class="div-block-2">-->
        <!--        <input-->
        <!--          type="text"-->
        <!--          class="form-field email-verify w-input"-->
        <!--          maxlength="1"-->
        <!--          name="field-2"-->
        <!--          data-name="Field 2"-->
        <!--          placeholder=""-->
        <!--          id="field-2"-->
        <!--          required=""-->
        <!--        />-->
        <!--        <input-->
        <!--          type="text"-->
        <!--          class="form-field email-verify w-input"-->
        <!--          maxlength="1"-->
        <!--          name="field-2"-->
        <!--          data-name="Field 2"-->
        <!--          placeholder=""-->
        <!--          id="field-2"-->
        <!--          required=""-->
        <!--        />-->
        <!--        <input-->
        <!--          type="text"-->
        <!--          class="form-field email-verify w-input"-->
        <!--          maxlength="1"-->
        <!--          name="field-2"-->
        <!--          data-name="Field 2"-->
        <!--          placeholder=""-->
        <!--          id="field-2"-->
        <!--          required=""-->
        <!--        />-->
        <!--        <input-->
        <!--          type="text"-->
        <!--          class="form-field email-verify w-input"-->
        <!--          maxlength="1"-->
        <!--          name="field-2"-->
        <!--          data-name="Field 2"-->
        <!--          placeholder=""-->
        <!--          id="field-2"-->
        <!--          required=""-->
        <!--        />-->
        <!--      </div>-->
        <FormulateInput
          type="submit"
          label="Reset password"
          @click="resetPassword"
          v-else
        />
      </FormulateForm>
      <div class="text-block-23">
        <div class="link-4" @click="resendOtp">Resend OTP</div>
      </div>
    </div>
    <div class="text-block-2">© {{ currentYear() }} Timeslate</div>
  </div>
</template>

<script>
import OtpInput from "otp-input-vue2";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";
import AuthRequest from "@/model/requests/AuthRequest";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import { mapState } from "vuex";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";

export default {
  name: "TimeslotResetOTPForm",
  components: { BaseComponentLoader, OtpInput },
  data() {
    return {
      completeModel: AuthRequest.completePasswordReset,
      userToken: "",
      formKey: 0,
      initiateModel: AuthRequest.initiateEnrollment,
      initiateResetModel: AuthRequest.initiatePasswordReset,
      resendModel: AuthRequest.resendOtp,
      isCodeValid: true
    };
  },
  computed: {
    ...mapState(["loader"]),
    ...mapState({
      passwordReset: state => state.auth.resetPassword,
      resetPasswordConfirm: state => state.auth.resetPasswordConfirm,
      email: state => state.auth.authEmail
    })
  },
  methods: {
    onCompleteHandler(code) {
      this.isCodeValid = false;
      this.completeModel.otp = code;
    },
    onPasteHandler(code) {
      this.completeModel.otp = code;
    },
    resetPassword() {
      // if (this.userToken.length !== 4) return;
      // this.completeModel.otp = this.userToken;
      this.completeModel.username = this.email;
      this.completeModel.password = this.passwordReset;
      this.completeModel.passwordConfirmation = this.resetPasswordConfirm;
      this.completeModel.countryCode = "234";
      StoreUtils.dispatch(
        StoreUtils.actions.auth.COMPLETE_RESET,
        this.completeModel
      );
    },
    resendOtp() {
      this.resendModel.username = this.email;
      this.resendModel.countryCode = "234";
      StoreUtils.dispatch(StoreUtils.actions.auth.RESEND_OTP, this.resendModel);
    },
    goToBack() {
      RouterUtils.changeRouteUrlTo("/new-password");
    },
    currentYear() {
      let current_date = new Date();
      let current_year = current_date.getFullYear();
      return current_year;
    }
  }
};
</script>

<style scoped>
.vue-otp-input >>> .separate-input-class {
  text-align: center;
  font-weight: bold;
  font-size: 25px;
  /*background-color: aquamarine;*/
  color: #256ff6;
  border: solid 2px #dcdde5;
  width: 48px;
  height: 48px;
}
</style>
